export const contactsData = {
    email: 'mdfarhansadiq17@gmail.com',
    phone: '+880 1816836486',
    address: 'Dhaka, Bangladesh',

    sheetAPI: ''
}